import { createAction, props } from '@ngrx/store'
import { EventTicketPackageProfileActivitiesEntity } from './event-ticket-package-profile-activities.models'
import { HttpErrorResponse } from '@angular/common/http'

export const syncEventTicketPackageProfileActivity = createAction(
  '[EventTicketPackageProfileActivities/API] Sync EventTicketPackageProfileActivity',
  props<{ uuid: string }>(),
)

export const syncEventTicketPackageProfileActivitySuccess = createAction(
  '[EventTicketPackageProfileActivities/API] Sync EventTicketPackageProfileActivity Success',
  props<{ activity: EventTicketPackageProfileActivitiesEntity }>(),
)

export const syncEventTicketPackageProfileActivityFailure = createAction(
  '[EventTicketPackageProfileActivities/API] Sync EventTicketPackageProfileActivity Failure',
  props<{ error: HttpErrorResponse; uuid?: string }>(),
)

export const deleteEventTicketPackageProfileActivity = createAction(
  '[EventTicketPackageProfileActivities/API] Delete EventTicketPackageProfileActivity',
  props<{ uuid: string }>(),
)

export const updateSelectedEventTicketPackageProfileActivityId = createAction(
  '[EventTicketPackageProfileActivities Page] Update Selected EventTicketPackageProfileActivity ID',
  props<{ uuid: string }>(),
)

export const clearSelectedEventTicketPackageProfileActivityId = createAction(
  '[EventTicketPackageProfileActivities Page] Clear Selected EventTicketPackageProfileActivity ID',
)

export const clearEventTicketPackageProfileActivities = createAction(
  '[EventTicketPackageProfileActivities] Clear EventTicketPackageProfileActivities',
)
